import * as React from "react";

import ContractForm from "../../../components/Forms/ManagementContract/ContractForm/FlowForm";

export default () => {
  return <ContractForm />;
};
